// extracted by mini-css-extract-plugin
module.exports = {"section":"BlogSection_section__1ZfwY","textSection":"BlogSection_textSection__gqsbn","previewSection":"BlogSection_previewSection__2Mhtg"};